import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default {
  install: (app) => {
    const options = {
      toastStyle: {
        width: '145px !important ',
        minHeight: '38px !important',
        maxHeight: '38px !important',
        padding: '8px 12px !important'
      },
      bodyStyle: {
        margin: 0,
        padding: 0,
        fontSize: '12px',
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      position: 'top-center',
      timeout: 2000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: false,
      draggablePercent: 0.6,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: false, // 'button',
      icon: false,
      rtl: false
    }

    app.use(Toast, options)
  }
}
